import { useEffect } from "react";
import styles from "./Notification.module.css";
import error from "/NotificationsIcons/rederror.svg";
import close from "/NotificationsIcons/closeCross.svg";
import success from "/NotificationsIcons/succsess.svg";
import warning from "/NotificationsIcons/warning.svg";
import { useNotificationStore } from "../../Store/NotificationStore";
import { Reward } from "../Reward/Reward";

const Notification = () => {
  const message = useNotificationStore((state) => state.notification.message);
  const type = useNotificationStore((state) => state.notification.type);
  const rewards = useNotificationStore((state) => state.notification.rewards);
  const closeNotification = useNotificationStore(
    (state) => state.closeNotification
  );
  const tg = window.Telegram.WebApp;

  useEffect(() => {
    if (tg && tg.HapticFeedback) {
        if (type === "Error") {
            tg.HapticFeedback.notificationOccurred("error");
        } else if (type === "Warning") {
            tg.HapticFeedback.notificationOccurred("warning");
        } else {
            tg.HapticFeedback.notificationOccurred("success");
        }
    } else {
        console.warn('Telegram WebApp or HapticFeedback is not available');
    }
}, [type]);

  // Группируем награды по типу и преобразуем в числа
  const dcReward = rewards?.find(reward => 
    reward.type === 'dc' || reward.type === 'DC')?.amount || 0;
  const ticketsReward = rewards?.find(reward => 
    reward.type === 'ticket' || reward.type === 'tickets')?.amount || 0;
  const characterReward = rewards?.find(reward => 
    reward.type === 'character')?.amount || 0;
  const usdtReward = rewards?.find(reward => 
    reward.type === 'USDT')?.amount || 0;

  return (
    <div className={styles.containerWrapper}>
      <div
        className={
          type === "Error"
            ? styles.blurCircleError
            : type === "Warning"
            ? styles.blurCircleWarning
            : styles.blurCircleSuccess
        }
      ></div>
      <div className={styles.icon}>
        <img
          className={styles.typeIcon}
          src={
            type === "Error" ? error : type === "Warning" ? warning : success
          }
          alt={
            type === "Error"
              ? "Error"
              : type === "Warning"
              ? "Warning"
              : "Success"
          }
        />
      </div>
      <div className={styles.message}>
        {message}
        {type === "Success" && rewards && (
          <div className={styles.rewards}>
            {dcReward > 0 && <Reward type="dc" amount={Number(dcReward)} />}
            {ticketsReward > 0 && <Reward type="ticket" amount={Number(ticketsReward)} />}
            {characterReward > 0 && <Reward type="character" amount={(characterReward)} />}
            {usdtReward > 0 && <Reward type="USDT" amount={Number(usdtReward)} />}
          </div>
        )}
      </div>
      <div onClick={() => closeNotification()} className={styles.closeButton}>
        <img className={styles.closeIcon} src={close} alt="close" />
      </div>
    </div>
  );
};

export default Notification;
